<ion-content>
  <ion-row class="p-0">
    <img src="././assets/icon/forgotPasswordtoprightCorner.png" class="forgotPasswordtoprightCorner">
    <div class="forgotCard">
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="text-center">
          <img class="h-80" src="././assets/icon/phiedgeSidebarpoweredbyIcon.jpg">
        </ion-col>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="mt-20 text-center">
          <div class="formLabelSemiBoldfs24 setNewPass">SET NEW PASSWORD</div>
        </ion-col>
      </ion-row>
      <form [formGroup]="loginForm" (ngSubmit)="onClickLogin()">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <img src="././assets/icon/lockIcon.svg" class="mailIcon">
            <input type="{{passwordShow}}" formControlName="password" (input)="validatePassword()" placeholder="New Password" class="inputstyle font_regular olnone form-control"
              autocomplete="off">
            <img src="././assets/icon/eye-show.png" class="eyeIcon cp" (click)="onEyeClick()" *ngIf="!showpwd">
            <img src="././assets/icon/eye-hide.png" class="eyeIcon cp" (click)="onEyeClick()" *ngIf="showpwd">
          </ion-col>
          <label class="red-cl font_regular fs-12 pl-5" *ngIf="formSubmitted && loginForm.controls['password'].hasError('required')">
            Password is required</label>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <img src="././assets/icon/lockIcon.svg" class="mailIcon">
            <input type="{{passwordShow}}" formControlName="confirmPassword" placeholder="Confirm New Password" class="inputstyle font_regular olnone form-control"
              autocomplete="off">
            <img src="././assets/icon/eye-show.png" class="eyeIcon cp" (click)="onEyeClick()" *ngIf="!showpwd">
            <img src="././assets/icon/eye-hide.png"  class="eyeIcon cp" (click)="onEyeClick()" *ngIf="showpwd">
          </ion-col>
          <label class="red-cl font_regular fs-12 pl-5" *ngIf="formSubmitted && loginForm.controls['confirmPassword'].hasError('required')">
            Confirm Password is required</label>
          <label class="red-cl font_regular fs-12 pl-5" *ngIf="cfmpwdAndpwd">Password and Confirm Password does not match.</label>
        </ion-row>
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="validation-feedback">
              <p [ngClass]="{'valid': validations.minLength, 'invalid': !validations.minLength}">
                <span [ngClass]="{'green-tick': validations.minLength, 'invalid-tick': !validations.minLength}">&#10003;</span>
                Minimum 8 characters
              </p>
              <p [ngClass]="{'valid': validations.capitalLetter, 'invalid': !validations.capitalLetter}">
                <span [ngClass]="{'green-tick': validations.capitalLetter, 'invalid-tick': !validations.capitalLetter}">&#10003;</span>
                At least one capital letter
              </p>
              <p [ngClass]="{'valid': validations.smallLetter, 'invalid': !validations.smallLetter}">
                <span [ngClass]="{'green-tick': validations.smallLetter, 'invalid-tick': !validations.smallLetter}">&#10003;</span>
                At least one small letter
              </p>
              <p [ngClass]="{'valid': validations.numericCharacter, 'invalid': !validations.numericCharacter}">
                <span [ngClass]="{'green-tick': validations.numericCharacter, 'invalid-tick': !validations.numericCharacter}">&#10003;</span>
                At least one numeric character
              </p>
              <p [ngClass]="{'valid': validations.specialCharacter, 'invalid': !validations.specialCharacter}">
                <span [ngClass]="{'green-tick': validations.specialCharacter, 'invalid-tick': !validations.specialCharacter}">&#10003;</span>
                At least one special character
              </p>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <button type="submit" class="text-center fs-16 fs_14ForMobile font_semibold login-btn">Save & Login</button>
          </ion-col>
        </ion-row>
      </form>
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="mt-10 text-center">
          <label class="formLabelRegularfs16">Back to&nbsp;<u class="fs-16 fs_14ForMobile font_medium cp link"
              (click)="backToLogin()">Login</u></label>
        </ion-col>
      </ion-row>
    </div>
    <img src="././assets/icon/forgotPasswordBottomLeftCorner.png" class="forgotPasswordBottomLeftCorner">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="d-flex justify-content-flex-end">
        <div class="bottomPosFixed">
          <div class="pl-10 fs-10 font_regular text_gray">Powered By:</div>
          <img class="powerdByIcon" src="././assets/icon/phiedgeSidebarpoweredbyIcon.jpg">
        </div>
      </ion-col>
    </ion-row>
  </ion-row>
</ion-content>